import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveDocumentKeyRequestFailure(documentId) {
      const req = getState().find(({ documentId: d }) => d === documentId);
      return req ? req.request.isFailure : false;
    },
    isRetrieveDocumentKeyRequestPending(documentId) {
      const req = getState().find(({ documentId: d }) => d === documentId);
      return req ? req.request.isPending : false;
    },
    isRetrieveDocumentKeyRequestSuccess(documentId) {
      const req = getState().find(({ documentId: d }) => d === documentId);
      return req ? req.request.isSuccessful : false;
    },
    retrieveDocumentKey(documentId) {
      const req = getState().find(({ documentId: d }) => d === documentId);
      return req ? req.key : "";
    },
  };
}

export { createSelector };
